<template>
  <div>
    <SaveInfo
      :isDataUpdating="isDataUpdating"
    ></SaveInfo>
    <div v-if="!isLoading && project !== null">
<!--      <div class="field">-->
<!--        <label>Участник кинофорума "Новый вектор"</label>-->
<!--        <div class="select-field">-->
<!--          <select>-->
<!--            <option value="Короткометражное кино">Роль 1</option>-->
<!--            <option value="Полнометражное кино">Роль 2</option>-->
<!--          </select>-->
<!--        </div>-->
<!--      </div>-->

      <template v-if="currentType === 'guest' || currentType === 'expert'">
        <h1 style="margin-bottom: 0; margin-top: 25px; padding-left: 25px; padding-right: 25px;" :data-projectid="project.id">Заявка на участие на кинофоруме "Новый вектор" для физического лица</h1>
<!--        <p style="padding-left: 25px; margin-top: 30px; font-size: 17px; padding-bottom: 0; margin-bottom: 0;">Тип анкеты: Анкета для физического лица</p>-->
      </template>
      <template v-else>
        <h1 style="margin-bottom: 0; margin-top: 25px; padding-left: 25px; padding-right: 25px;" :data-projectid="project.id">Заявка на участие на кинофоруме "Новый вектор" для юридического лица</h1>
<!--        <p style="padding-left: 25px; margin-top: 30px; font-size: 17px; padding-bottom: 0; margin-bottom: 0;">Тип анкеты: Анкета для юридического лица</p>-->
      </template>


      <Form id="clientForm" ref="clientForm" v-slot="{errors}">
        <div class="errors-block" v-if="Object.keys(errors).length > 0 && (project.noPremiere || this.isSubmitted)">
          <b>Пожалуйста, заполните поля:</b>
          <ul>
            <li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}" обязательно для заполнения</li>
          </ul>
        </div>

        <template v-if="currentType === ''">

          <Field style="display: none" v-model="project.project_data.part_role" name="part_role" :rules="isRequired"></Field>
          <BaseSelectWithOther
              v-model="project.project_data.part_role"
              label="Тип организации"
              :is-required="true"
              other-placeholder="Впишите вашу предполагаемую роль в качестве участника кинофорума"
              :values="[
            {
              'label': 'Кинокомиссия',
              'value': 'Кинокомиссия'
            },
            {
              'label': 'Кинокомпания/Продюсерский центр',
              'value': 'Кинокомпания/Продюсерский центр'
            },
            {
              'label': 'Образовательное учреждение (кинообразование)',
              'value': 'Образовательное учреждение (кинообразование)'
            }
        ]"
              @onChange="saveData"
          ></BaseSelectWithOther>

          <Field v-model="project.name" name="project_name" v-slot="{ field, handleChange }" :rules="isRequired">
            <BaseInput
                label="Наименование организации полностью"
                :isDataUpdated="isDataUpdating"
                :is-required="true"
                :isFormSubmitted="isSubmitted"
                :modelValue="field.value"
                @onChange="event => {handleChange(event, true); saveData()}"
            ></BaseInput>
          </Field>


          <Field style="display: none" v-model="project.city" name="project_city" :rules="isRequired"></Field>
          <Field style="display: none" v-model="project.region" name="project_region" :rules="isRequired"></Field>

          <BaseLocation
              label-city="Город нахождения организации"
              label-region="Регион нахождения организации"
              :is-city-required="true"
              :is-region-required="true"
              @onChange="saveData"
              v-model:city="project.city"
              v-model:region="project.region"
          ></BaseLocation>

          <Field v-model="project.tagline" name="project_tagline" v-slot="{ field, handleChange }" :rules="isRequired">
            <BaseInput
                :modelValue="field.value"
                @onChange="event => {handleChange(event, true); saveData()}"
                label="Полный юридический адрес организации"
                :is-required="true"
                :isDataUpdated="isDataUpdating"
                :isFormSubmitted="isSubmitted"
            ></BaseInput>
          </Field>

          <Field style="display: none" v-model="project.logline" name="project_logline" :rules="isRequired"></Field>
          <BaseInput
              label="Полный фактический адрес организации"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.logline"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.film_rights_phone" name="filmRightsPhone" :rules="isRequired"></Field>
          <BaseInput
              label="Контактный телефон организации"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.film_rights_phone"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.film_rights_email" name="filmRightsEmail" :rules="isRequired"></Field>
          <BaseInput
              label="E-mail организации"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.film_rights_email"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.scenario_author" name="scenarioAuthor" :rules="isRequired"></Field>
          <BaseInput
              label="ФИО руководителя"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.scenario_author"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.producer" name="producer" :rules="isRequired"></Field>
          <BaseInput
              label="Ссылка на фотографию руководителя в формате PNG (для каталога)"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.producer"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.video_link" name="videoLink" :rules="isRequired"></Field>
          <BaseInput
              label="Ссылка на логотип организации в формате PNG (для каталога)"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.video_link"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.annotation" name="annotation" :rules="isRequired"></Field>
          <div class="field">
            <label class="req">Направления работы организации + (ОКВЭД)</label>
            <textarea
                :disabled="isDataUpdating"
                placeholder="Виды деятельности, например: кинопроизводство, кинопрокат, фестивальное деятельность, сценарное агентство, кинокомпания и другое."
                v-model="project.annotation"
                @change="saveData"
            ></textarea>
          </div>

          <!--      <TinymceEditor-->
          <!--          label="Основные реализованные проекты и программы за последние 3 лет."-->
          <!--          :isDataUpdating="isDataUpdating"-->
          <!--          v-model="project.additionalInfo"-->
          <!--      ></TinymceEditor>-->

          <h2>Основные реализованные проекты и программы за последние 3 года</h2>

          <template v-for="(project,index) in project.project_data.projects" :key="index">
            <div style="padding: 20px; border-radius: 20px; border: 1px solid #ccc; margin-bottom: 30px;">
              <p style="text-align: right"><a @click="removeProject(index)"><FontAwesomeIcon style="font-size: 20px;" icon="close"></FontAwesomeIcon></a></p>
              <BaseInput
                  label="Название проекта"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  :is-required="true"
                  v-model="project.name"
                  @onChange="saveData"
              ></BaseInput>
              <BaseInput
                  label="Год реализации"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  v-model="project.year"
                  :is-required="true"
                  @onChange="saveData"
              ></BaseInput>
              <BaseInput
                  label="Ссылка на информацию о проекте"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  v-model="project.link"
                  :is-required="true"
                  @onChange="saveData"
              ></BaseInput>
              <div class="field">
                <label :class="this.isFieldRequired('tagline') ? 'req': ''" for="project_tagline">Особенности проекта</label>
                <textarea
                    :disabled="isDataUpdating"
                    v-model="project.description"
                    @change="saveData"
                ></textarea>
              </div>
            </div>
          </template>
          <p><a @click="addProject" class="button3">Добавить</a></p>

<!--          <Field style="display: none" v-model="project.scenario" name="scenario" :rules="isRequired"></Field>-->
<!--          <BasePdfUploader-->
<!--              :project="project"-->
<!--              :currentProjectId="currentProjectId"-->
<!--              label="Презентация для форума (в формате PDF, макс. 20 мегабайт)"-->
<!--              :value="project.scenario"-->
<!--              :is-required="true"-->
<!--              pathToUpload="/project/uploadProjectScenario/"-->
<!--              object-key="scenario"-->
<!--              @onChange="getData"-->
<!--              isTransKey=false-->
<!--          ></BasePdfUploader>-->

          <BaseInput
              label="Видеопрезентационный ролик/Шоурил"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              placeholder="Ссылка на презентационный ролик/шоурил ваших проектов до 45-60 секунд"
              v-model="project.social_videolink"
              @change="saveData"
          ></BaseInput>

          <label style="cursor: pointer" for="speech">Вы планируете принять участие в качестве слушателя или выступить с докладом?</label>
          <input style="cursor: pointer" @change="saveData" v-model="project.project_data.plan_report" type="radio" name="speech" value="yes" id="yes">
          <label  style="cursor: pointer" for="yes">Выступить с докладом</label>

          <input style="cursor: pointer" @change="saveData" v-model="project.project_data.plan_report" type="radio" name="speech" value="no" id="no">
          <label style="cursor: pointer" for="no">Слушатель</label>

          <template v-if="project.project_data.plan_report === 'yes'">
            <Field style="display: none" v-model="project.project_data.report_theme" name="report_theme" :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.project_data.report_presentation" name="report_presentation" :rules="isRequired"></Field>

            <BaseInput
                label="Тема доклада"
                :is-required="true"
                :isDataUpdated="isDataUpdating"
                :isFormSubmitted="isSubmitted"
                v-model="project.project_data.report_theme"
                @onChange="saveData"
            ></BaseInput>

            <p><a href="https://disk.yandex.ru/i/YN6qXkA2aSX0QQ" target="_blank">Открыть бриф <FontAwesomeIcon icon="file"></FontAwesomeIcon></a></p>

            <BaseInput
                label="Ссылка на презентацию (презентацию необходимо выполнить, опираясь на бриф)"
                :is-required="true"
                :isDataUpdated="isDataUpdating"
                :isFormSubmitted="isSubmitted"
                v-model="project.project_data.report_presentation"
                @onChange="saveData"
            ></BaseInput>
          </template>

          <h2>Список представителей</h2>

            <Field style="display: none" v-model="project.project_data.represents[0].fio" name="represent_fio" :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.project_data.represents[0].phone" name="represent_phone" :rules="isRequired"></Field>


          <template v-for="(represent,index) in project.project_data.represents" :key="index">
            <div style="padding: 20px; border-radius: 20px; border: 1px solid #ccc; margin-bottom: 30px;">
              <p style="text-align: right"><a @click="removeRepresent(index)"><FontAwesomeIcon style="font-size: 20px;" icon="close"></FontAwesomeIcon></a></p>
              <BaseInput
                  label="Фамилия имя отчество представителя"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  :is-required="true"
                  v-model="represent.fio"
                  @onChange="saveData"
              ></BaseInput>
              <BaseInput
                  label="Телефон представителя"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  :is-required="true"
                  v-model="represent.phone"
                  @onChange="saveData"
              ></BaseInput>
              <BaseInput
                  label="Email представителя"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  v-model="represent.email"
                  @onChange="saveData"
              ></BaseInput>
              <BaseInput
                  label="Укажите, пожалуйста, корректное название должности, в т.ч. для включения в каталог Форума и использования в иных публичных материалах"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  v-model="represent.position"
                  @onChange="saveData"
              ></BaseInput>

              <BaseInput
                  label="Укажите, пожалуйста, ссылку на фотографию для включения в раздел информации и каталог Форума. (Формат: цветное, крупный план, jpeg/png)"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  v-model="represent.link"
                  @onChange="saveData"
              ></BaseInput>

<!--              <BaseInput-->
<!--                  label="Номер паспорта"-->
<!--                  :isDataUpdated="isDataUpdating"-->
<!--                  :isFormSubmitted="isSubmitted"-->
<!--                  v-model="represent.passport"-->
<!--                  @onChange="saveData"-->
<!--              ></BaseInput>-->
            </div>

          </template>
          <p><a @click="addRepresent" class="button3">Добавить</a></p>

          <Field style="display: none" v-model="project.project_data.accept" name="data_accept" :rules="isRequired"></Field>
          <div id="user_form" class="field">
            <input @change="saveData" v-model="project.project_data.accept" type="checkbox" id="user_edit_data_accept" required="required">
            <label class="req required" for="user_edit_data_accept">согласие на использование материалов для каталога + согласие на использование персональных данных + гарантия предоставления правдивых сведений</label>
          </div>
        </template>

        <template v-if="currentType === 'guest' || currentType === 'expert'">

          <Field style="display: none" v-model="project.name" name="name" :rules="isRequired"></Field>
          <BaseInput
              label="Фамилия имя отчество"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.name"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.film_rights_phone" name="filmRightsPhone" :rules="isRequired"></Field>
          <BaseInput
              label="Контактный телефон"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.film_rights_phone"
              @onChange="saveData"
          ></BaseInput>

          <Field style="display: none" v-model="project.city" name="project_city" :rules="isRequired"></Field>
          <Field style="display: none" v-model="project.region" name="project_region" :rules="isRequired"></Field>

          <BaseLocation
              label-city="Город нахождения организации"
              label-region="Регион нахождения организации"
              :is-city-required="true"
              :is-region-required="true"
              @onChange="saveData"
              v-model:city="project.city"
              v-model:region="project.region"
          ></BaseLocation>

          <BaseInput
              label="Укажите, пожалуйста, корректное название должности, в т.ч. для включения в каталог Форума и использования в иных публичных материалах"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.motivation"
              @onChange="saveData"
          ></BaseInput>


          <Field style="display: none" v-model="project.producer" name="producer" :rules="isRequired"></Field>
          <BaseInput
              label="Укажите, пожалуйста, ссылку на фотографию для включения в раздел информации и каталог Форума. (Формат: цветное, крупный план, jpeg/png)"
              :is-required="true"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.producer"
              @onChange="saveData"
          ></BaseInput>

          <h2>Основные реализованные проекты и программы за последние 3 года</h2>

          <template v-for="(project,index) in project.project_data.projects" :key="index">
            <div style="padding: 20px; border-radius: 20px; border: 1px solid #ccc; margin-bottom: 30px;">
              <p style="text-align: right"><a @click="removeProject(index)"><FontAwesomeIcon style="font-size: 20px;" icon="close"></FontAwesomeIcon></a></p>
              <BaseInput
                  label="Название проекта"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  :is-required="true"
                  v-model="project.name"
                  @onChange="saveData"
              ></BaseInput>
              <BaseInput
                  label="Год реализации"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  v-model="project.year"
                  :is-required="true"
                  @onChange="saveData"
              ></BaseInput>
              <BaseInput
                  label="Ссылка на информацию о проекте"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  v-model="project.link"
                  :is-required="true"
                  @onChange="saveData"
              ></BaseInput>
              <div class="field">
                <label :class="this.isFieldRequired('tagline') ? 'req': ''" for="project_tagline">Особенности проекта</label>
                <textarea
                    :disabled="isDataUpdating"
                    v-model="project.description"
                    @change="saveData"
                ></textarea>
              </div>
            </div>
          </template>
          <p><a @click="addProject" class="button3">Добавить</a></p>

<!--          <Field style="display: none" v-model="project.scenario" name="scenario" :rules="isRequired"></Field>-->
<!--          <BasePdfUploader-->
<!--              :project="project"-->
<!--              :currentProjectId="currentProjectId"-->
<!--              label="Презентация для форума (в формате PDF, макс. 20 мегабайт)"-->
<!--              :value="project.scenario"-->
<!--              :is-required="true"-->
<!--              pathToUpload="/project/uploadProjectScenario/"-->
<!--              object-key="scenario"-->
<!--              @onChange="getData"-->
<!--              isTransKey=false-->
<!--          ></BasePdfUploader>-->

          <BaseInput
              label="Видеопрезентационный ролик/Шоурил"
              placeholder="Ссылка на презентационный ролик/шоурил ваших проектов до 45-60 секунд"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
              v-model="project.social_videolink"
              @change="saveData"
          ></BaseInput>

          <div style="margin-bottom: 20px;">
            <label style="cursor: pointer" for="speech">Вы планируете принять участие в качестве слушателя или выступить с докладом?</label>
            <input style="cursor: pointer" @change="saveData" v-model="project.project_data.plan_report" type="radio" name="speech" value="yes" id="yes">
            <label  style="cursor: pointer" for="yes">Выступить с докладом</label>

            <input style="cursor: pointer" @change="saveData" v-model="project.project_data.plan_report" type="radio" name="speech" value="no" id="no">
            <label style="cursor: pointer" for="no">Слушатель</label>
          </div>


          <template v-if="project.project_data.plan_report === 'yes'">
            <Field style="display: none" v-model="project.project_data.report_theme" name="report_theme" :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.project_data.report_presentation" name="report_presentation" :rules="isRequired"></Field>
            <BaseInput
                label="Тема доклада"
                :is-required="true"
                :isDataUpdated="isDataUpdating"
                :isFormSubmitted="isSubmitted"
                v-model="project.project_data.report_theme"
                @onChange="saveData"
            ></BaseInput>

            <p><a href="https://disk.yandex.ru/i/YN6qXkA2aSX0QQ" target="_blank">Открыть бриф <FontAwesomeIcon icon="file"></FontAwesomeIcon></a></p>

            <BaseInput
                label="Ссылка на презентацию (презентацию необходимо выполнить, опираясь на бриф)"
                :is-required="true"
                :isDataUpdated="isDataUpdating"
                :isFormSubmitted="isSubmitted"
                v-model="project.project_data.report_presentation"
                @onChange="saveData"
            ></BaseInput>
          </template>
        </template>

        <template v-if="project.noPremiere">
          <p style="font-weight: bold;">Ваша заявка принята</p>
        </template>
        <template v-else>
          <p><a @click="sendForm" class="button3">Отправить</a></p>
        </template>


      </Form>

    </div>
    <div v-else style="text-align: center">
      <BaseLoader></BaseLoader>
    </div>

  </div>
</template>

<script>
import SaveInfo from "./Base/SaveInfo";
import BaseInput from "./Base/BaseInput3";
import BaseSelectWithOther from "./Base/BaseSelectWithOther";
import BaseLoader from "./Base/BaseLoader";
import BaseLocation from "./Base/BaseLocationOnlyCityRegion";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClose, faFile } from '@fortawesome/free-solid-svg-icons';
import { Field, Form } from 'vee-validate';
import ValidationService from "../services/ValidationService"

library.add(faClose);
library.add(faFile);

export default {
  name: 'ForumForm',
  data() {
    return {
      project: null,
      tabNum: 1,
      errors: [],
      isLoading: true,
      isSubmitted: false,
      isDataUpdating: false,
      validationRules: [],
      simpleSchema: {}
    }
  },
  components: {
    SaveInfo,
    BaseInput,
    BaseLoader,
    //TinymceEditor,
    //BasePdfUploader,
    BaseLocation,
    BaseSelectWithOther,
    FontAwesomeIcon,
    Form,
    Field
  },
  mounted: function () {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }
    this.getData();
  },
  computed: {
    currentProjectId: function () {
      return window.projectId;
    },
    currentType: function () {
      return window.type;
    }
  },
  methods: {
    async getData() {
      const projectResponse = await axios.get('/api/projects/' + window.projectId, {
        headers: {
          'Accept': 'application/json',
        }
      })

      this.project = projectResponse.data;

      try {
        let project_data = {
          represents: [],
          part_role: '',
          accept: false,
          plan_report: 'no',
          report_theme: '',
          report_presentation: '',
          projects: []
        };

        if (this.project.project_data === null || Array.isArray(this.project.project_data)) {
          this.project.project_data = {};
        }

        for (var key in project_data) {
          if (key === 'represents') {
            this.project.project_data[key] = projectResponse.data.project_data[key] ?? [
              {
                fio: '',
                position: '',
                phone: '',
                email: '',
                link: ''
              }
            ];
          }
          else if (key === 'projects') {
            this.project.project_data[key] = projectResponse.data.project_data[key] ?? [
              {
                name: '',
                year: '',
                link: '',
                description: ''
              }
            ];
          } else if (key === 'plan_report') {
            this.project.project_data[key] = projectResponse.data.project_data[key] ?? 'no';
          }
          else {
            this.project.project_data[key] = projectResponse.data.project_data[key] ?? '';
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        this.isDataUpdating = false;
      }
    },
    addRepresent() {
      this.project.project_data.represents.push({
        fio: '',
        position: '',
        phone: '',
        email: '',
        link: ''
      });
    },
    removeRepresent(index) {
      this.project.project_data.represents.splice(index, 1);
      this.saveData();
    },
    addProject() {
      this.project.project_data.projects.push({
        name: '',
        year: '',
        link: '',
        description: ''
      });
    },
    removeProject(index) {
      this.project.project_data.projects.splice(index, 1);
      this.saveData();
    },
    isFieldRequired() {
      return false;
    },
    saveData: function () {
      const self = this;

      let hasErrors = false;
      this.$refs.clientForm.validate().then((valid) => {
        if (Object.keys(valid.errors).length > 0) {
          hasErrors = true
        }

        //noPremiere - заявка опубликована
        if ((!this.isDataUpdating && !hasErrors) || !this.project.noPremiere) {
          this.isDataUpdating = true;


          axios.patch('/api/projects/' + window.projectId,
              {
                'name': self.project.name,
                'city': self.project.city,
                'region': self.project.region,
                'logline': self.project.logline,
                'filmRightsPhone': self.project.film_rights_phone,
                'filmRightsEmail': self.project.film_rights_email,
                'scenarioAuthor': self.project.scenario_author,
                'producer': self.project.producer,
                'videoLink': self.project.video_link,
                'annotation': self.project.annotation,
                'motivation': self.project.motivation,
                'socialVideolink': self.project.social_videolink,
                'tagline': self.project.tagline,
                'projectData': self.project.project_data,
              },
              {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/merge-patch+json',
                }
              }
          ).then((response) => {
            if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
              alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
              window.location.reload();
            }
            self.getData()
          }).catch(error => {
            console.log(error);
            alert('Ошибка получения данных')
          });
        }
      });
    },
    async sendForm() {
      const self = this;
      this.isSubmitted = true;
      this.$refs.clientForm.validate();

      let hasErrors = false;
      this.$refs.clientForm.validate().then((valid) => {
        if (Object.keys(valid.errors).length > 0) {
          hasErrors = true
        }

        if (!hasErrors) {
          axios.patch('/api/projects/' + window.projectId,
              {
                'noPremiere': true
              },
              {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/merge-patch+json',
                }
              }
          ).then(() => {
            alert('Ваша заявка принята');
            self.getData();
          })
        } else {
          if (document.getElementById("clientForm")) {
            document.getElementById("clientForm").scrollIntoView();
          }
        }
      });
    },
    isRequired(val) {
      return ValidationService.isRequired(val);
    },
    getFieldNameByIndex(index) {
      let res = '';
      if (index === 'project_name') {
        res = 'Наименование организации полностью';
      }
      else if (index === 'project_tagline') {
        res = 'Полный юридический адрес организации';
      }
      else if (index === 'project_city') {
        res = 'Город нахождения организации';
      }
      else if (index === 'project_region') {
        res = 'Регион нахождения организации';
      }
      else if (index === 'project_logline') {
        res = 'Полный фактический адрес организации';
      }
      else if (index === 'filmRightsPhone') {
        res = 'Контактный телефон организации';
      }
      else if (index === 'filmRightsEmail') {
        res = 'E-mail организации';
      }
      else if (index === 'scenarioAuthor') {
        res = 'ФИО руководителя';
      }
      else if (index === 'producer') {
        res = 'Ссылка на фотографию руководителя в формате PNG (для каталога)';
      }
      else if (index === 'videoLink') {
        res = 'Ссылка на логотип организации в формате PNG (для каталога)';
      }
      else if (index === 'annotation') {
        res = 'Направления работы организации + (ОКВЭД)';
      }
      else if (index === 'socialVideolink') {
        res = 'Видеопрезентационный ролик/Шоурил';
      }
      else if (index === 'data_accept') {
        res = 'Согласие на использование материалов';
      }
      else if (index === 'scenario') {
        res = 'Презентация для форума';
      }
      else if (index === 'report_theme') {
        res = 'Тема доклада';
      }
      else if (index === 'report_presentation') {
        res = 'Ссылка на презентацию';
      }
      else if (index === 'name') {
        res = 'Фамилия имя отчество';
      }
      else if (index === 'part_role') {
        res = 'Тип организации';
      }
      else if (index === 'represent_fio') {
        res = 'Фамилия имя отчество представителя';
      }
      else if (index === 'represent_phone') {
        res = 'Телефон представителя';
      }

      return res;
    }
  }
}
</script>

<style>
.errors-block {
  color: red;
  border: 1px solid #999;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
}
</style>
